module.exports = "/_next/static/images/954896161387444df6cc466d97d8f8d8-adjust-credit-limit.gif.webp";